// extracted by mini-css-extract-plugin
export default {"viewLinkBtn":"ButtonPill_viewLinkBtn__Kdhqo","viewLinkBtnLabel":"ButtonPill_viewLinkBtnLabel__pP+58"};